import { Alert, Snackbar } from "@mui/material";
import { useState, useEffect} from "react";
import { useTranslation } from "react-i18next";

const NoInternetSnackAlert = () => {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, []);

  return (
    <Snackbar 
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={!isOnline}
    >
      <Alert
        sx={{ width: '100%' }}
        severity="error"
        variant="filled"        
      >
        {t('internet_connection')}
      </Alert>
    </Snackbar>
  )
}

export default NoInternetSnackAlert;